import React from 'react'
import {Navigate, useLocation} from "react-router-dom"

const ProtectedRoute = ({children, isAllowed, isGettingUserInfo}: {children: JSX.Element, isAllowed: boolean, isGettingUserInfo: boolean}) => {
    const location = useLocation();
    if(!isGettingUserInfo) return null
    if(!isAllowed) {
        return <Navigate to="/" state={{ from: location }} replace />
    }
    return children;
};

export default ProtectedRoute;
